exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".register-card[_v-2f886585]{width:100%}.modal[_v-2f886585]{position:absolute;top:0;bottom:0;left:0;right:0;margin:auto;height:220px;width:400px;background-color:#fff;z-index:1}.mdl-dialog[_v-2f886585]{width:400px}.modal-big[_v-2f886585]{position:fixed;top:80px;bottom:120px;left:auto;right:auto;background-color:#fff;z-index:1}.modal-big .mdl-dialog[_v-2f886585]{width:90vw;height:100%;overflow-y:auto}@media (min-width:840px){.modal-big .mdl-dialog[_v-2f886585]{width:40vw}}a[_v-2f886585]{text-decoration:none}.center-text[_v-2f886585]{margin-top:35px}.ga-inline[_v-2f886585]{display:inline!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-2f886585&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./~/eslint-loader!./src/client/forms/RegisterForm.vue
// module id = 299
// module chunks = 0